<script setup lang="ts">
// const { isNavbarOpen } = storeToRefs(useLayoutStore())
</script>

<template>
  <main class="bg-background flex-1 rounded-4xl -mt-8 pt-20 md:pt-24 z-10 relative paper-background">
    <!-- <div
      :class="isNavbarOpen ? 'top-0' : 'top-18 md:top-22'"
      class="absolute inset-x-0 h-full pointer-events-none -z-10 transition-[top] duration-500 ease-in-out will-change-[top]"
    >
      <div class="container relative size-full border border-muted transform-gpu grid-background">
        <div class="absolute inset-y-0 left-5.5 sm:left-11 md:left-17 border-l-2 border-l-destructive" />
      </div>
    </div> -->
    <HomeHeroSection />
    <LazyVisibleHomeServicesSection hydrate-on-visible />
    <LazyVisibleHomePortfolioSection hydrate-on-visible />
    <LazyVisibleHomeContactSection hydrate-on-visible />
  </main>
</template>

<style scoped>
.grid-background {
  background-image:
    linear-gradient(90deg, var(--muted) 2px, rgba(0, 0, 0, 0) 2px),
    linear-gradient(var(--muted) 2px, rgba(0, 0, 0, 0) 2px);
  background-size: 1.5rem 1.5rem;
  background-position: -1px -1px;
  background-repeat: repeat;
}
</style>
